import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = {
  class: "p-fluid grid justify-content-center align-items-center flex align-content-center mr-0",
  style: {"min-height":"100vh"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "field"
}
const _hoisted_4 = {
  key: 1,
  class: "field"
}
const _hoisted_5 = {
  key: 7,
  class: "p-3"
}
const _hoisted_6 = { class: "p-3" }
const _hoisted_7 = { class: "grey col-12 text-center" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_10 = { class: "block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_LoginFields = _resolveComponent("LoginFields")!
  const _component_RegisterFields = _resolveComponent("RegisterFields")!
  const _component_UpdatePasswordFields = _resolveComponent("UpdatePasswordFields")!
  const _component_RequestPasswordResetFields = _resolveComponent("RequestPasswordResetFields")!
  const _component_ResetPasswordFields = _resolveComponent("ResetPasswordFields")!
  const _component_ValidateSelfRegistrationFields = _resolveComponent("ValidateSelfRegistrationFields")!
  const _component_SelfRegisterFields = _resolveComponent("SelfRegisterFields")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Panel, { class: "col-12 md:col-6 lg:col-4 p-panel-content" }, {
        header: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.styles.logo,
            style: {"height":"45px"}
          }, null, 8, _hoisted_2)
        ]),
        default: _withCtx(() => [
          (_ctx.loginError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_Message, {
                  severity: "error",
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loginError = ''))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.loginError), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.showTopInfoMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_Message, {
                  severity: "info",
                  onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.infoMessage = ''))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.infoMessage), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            (_ctx.currentMode === _ctx.AuthFlowMode.Login)
              ? (_openBlock(), _createBlock(_component_LoginFields, {
                  key: 0,
                  ref: "activeFlow",
                  onSubmit: _ctx.onLogin
                }, null, 8, ["onSubmit"]))
              : (_ctx.currentMode === _ctx.AuthFlowMode.Register)
                ? (_openBlock(), _createBlock(_component_RegisterFields, {
                    key: 1,
                    ref: "activeFlow",
                    onSubmit: _ctx.onRegister
                  }, null, 8, ["onSubmit"]))
                : (_ctx.currentMode === _ctx.AuthFlowMode.UpdatePassword)
                  ? (_openBlock(), _createBlock(_component_UpdatePasswordFields, {
                      key: 2,
                      ref: "activeFlow",
                      onSubmit: _ctx.onUpdatePassword
                    }, null, 8, ["onSubmit"]))
                  : (_ctx.currentMode === _ctx.AuthFlowMode.RequestPasswordReset)
                    ? (_openBlock(), _createBlock(_component_RequestPasswordResetFields, {
                        key: 3,
                        ref: "activeFlow",
                        onSubmit: _ctx.onRequestPasswordReset
                      }, null, 8, ["onSubmit"]))
                    : (_ctx.currentMode === _ctx.AuthFlowMode.ResetPassword)
                      ? (_openBlock(), _createBlock(_component_ResetPasswordFields, {
                          key: 4,
                          ref: "activeFlow",
                          onSubmit: _ctx.onResetPassword
                        }, null, 8, ["onSubmit"]))
                      : (_ctx.currentMode === _ctx.AuthFlowMode.ValidateRegistration)
                        ? (_openBlock(), _createBlock(_component_ValidateSelfRegistrationFields, {
                            key: 5,
                            ref: "activeFlow",
                            fields: _ctx.selfRegistrationFields,
                            onSubmit: _ctx.onValidateSelfRegistration,
                            onError: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loginError = $event))
                          }, null, 8, ["fields", "onSubmit"]))
                        : (_ctx.currentMode === _ctx.AuthFlowMode.SelfRegister)
                          ? (_openBlock(), _createBlock(_component_SelfRegisterFields, {
                              key: 6,
                              ref: "activeFlow",
                              requirePassword: !_ctx.useEmailSelfRegistration,
                              onSubmit: _ctx.onSelfRegister
                            }, null, 8, ["requirePassword", "onSubmit"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createVNode(_component_Message, { severity: "info" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.infoMessage || 'If your registration can be completed by email, a message has been sent with a link to continue.'), 1)
                                ]),
                                _: 1
                              })
                            ])),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.showSubmitButton)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    loading: _ctx.loginLoading,
                    type: "submit",
                    label: _ctx.submitButtonLabel,
                    disabled: _ctx.loginLoading
                  }, null, 8, ["loading", "label", "disabled"]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ]),
        _: 1
      }),
      _createElementVNode("span", _hoisted_7, [
        _createElementVNode("a", {
          class: _normalizeClass([_ctx.loginActive, "login"]),
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleLoginClick && _ctx.handleLoginClick(...args)))
        }, "Login", 2),
        _hoisted_8,
        _createElementVNode("a", {
          class: _normalizeClass([_ctx.registerActive, "login"]),
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleRegisterClick && _ctx.handleRegisterClick(...args)))
        }, "Register", 2),
        (_ctx.allowPasswordReset)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_9,
              _createElementVNode("a", {
                class: _normalizeClass([_ctx.resetPasswordActive, "login"]),
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleResetPasswordClick && _ctx.handleResetPasswordClick(...args)))
              }, "Reset Password", 2)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_Footer, { class: "footer" })
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showPasswordValidationError,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showPasswordValidationError) = $event)),
      header: "Password Validation Error"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passwordErrorDialogLines, (line) => {
            return (_openBlock(), _createElementBlock("span", {
              key: line,
              class: "block ml-1",
              style: {"min-height":"20px"}
            }, _toDisplayString(line), 1))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}